import { render, staticRenderFns } from "./documentRevisionUploader.vue?vue&type=template&id=035eb02e&"
import script from "./documentRevisionUploader.vue?vue&type=script&lang=js&"
export * from "./documentRevisionUploader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports